import {Observable}                  from 'rxjs';
import {distinctUntilChanged, pluck} from 'rxjs/operators';

import Captions from '../../../State/Stores/Captions/Captions';
import Track    from '../../../State/Stores/Captions/Track';

const createActiveTrackStream = (
    captionsStoreUpdate$: Observable<Captions>
): Observable<Track> =>
    captionsStoreUpdate$
        .pipe(
            pluck<Captions, Track>('activeTrack'),
            distinctUntilChanged()
        );

export default createActiveTrackStream;